import { useIntl } from 'react-intl';
import { LinkedTaskTemplateInput, TaskTemplate } from '../../../core/api/rtk/taskTemplatesApi';
import LinkedTaskTemplateField from './LinkedTaskTemplateField';
import TaskTemplateLink from './TaskTemplateLink';

interface TaskTemplateLinkedTabProps {
  task?: TaskTemplate;
  editing?: boolean;
  value?: LinkedTaskTemplateInput[];
  onChange?: (next: LinkedTaskTemplateInput[]) => void;
  disabled?: boolean;
}

// Mirrors views/tasks/components/TaskLinkedTab.tsx: in view mode renders the
// read-only TaskTemplateLink card list (with inline unlink), in edit mode renders
// the controlled LinkedTaskTemplateField editor. The parent form owns the
// edit-mode value/onChange so the upsert payload can be shipped alongside
// the rest of the TaskTemplate patch on save.
export const TaskTemplateLinkedTab = ({
  task,
  editing = false,
  value = [],
  onChange,
  disabled = false,
}: TaskTemplateLinkedTabProps): JSX.Element => {
  const intl = useIntl();
  if (!editing) {
    return <TaskTemplateLink task={task} />;
  }
  if (!onChange) {
    return (
      <div>
        {intl.formatMessage({
          id: 'linkedTasksUneditable',
          defaultMessage: 'Linked tasks are not editable in this view.',
        })}
      </div>
    );
  }
  return (
    <LinkedTaskTemplateField
      value={value}
      onChange={onChange}
      excludeTaskId={task?.id}
      disabled={disabled}
    />
  );
};

export default TaskTemplateLinkedTab;
